import type { AssetDTO } from '@gearbelt/global';

export const PREVIEW_ASSET_ID = 'mock-asset-id';

// Stands in for the record's asset where there is no record (designer canvas); fields skip asset lookups for this id.
export const PREVIEW_ASSET = { id: PREVIEW_ASSET_ID } as AssetDTO;
